import type { DocPageContent } from '../docs-content'

const page = {
  order: 10,
  slug: 'properties',
  title: '片段属性',
  description:
    '变换、裁剪、不透明度与混合，以及每种片段类型特有的控件。',
  category: '核心编辑',
  related: ['audio', 'text-captions-subtitles', 'effects-color', 'keyframes'],
  sections: [
    {
      title: '选择如何决定面板内容',
      blocks: [
        {
          kind: 'list',
          items: [
            '选中一个片段以编辑其全部属性。',
            '选中多个片段可一次性更改它们共有的某个属性。',
            '面板仅显示适用于当前所选内容的属性组标签页。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '**混合**值表示所选片段当前并未共享该设置；更改它会将一个值应用到全部片段。',
        },
      ],
    },
    {
      title: '可视片段共有的控件',
      blocks: [
        {
          kind: 'list',
          items: [
            '**变换**：位置、大小、旋转和锚点。',
            '**裁剪**：从每条边向内裁剪，并提供裁剪边缘的柔化控件。',
            '**不透明度**与**混合**：让片段淡入淡出，并选择它如何与下方图层合成。',
            '**视频**：视频片段的播放速度与相关时序。',
          ],
        },
        {
          kind: 'note',
          tone: 'tip',
          text: '许多数值控件可以动画化——留意数值旁的**关键帧**开关。',
        },
      ],
    },
    {
      title: '类型专属控件',
      blocks: [
        {
          kind: 'table',
          headers: ['片段类型', '控件'],
          rows: [
            ['音频', '增益、淡入/淡出、音高，以及每个片段独立的均衡器（见音频编辑）。'],
            [
              '文本',
              '内容、字体、大小、颜色、对齐、背景、间距、特效与动画（见文本页面）。',
            ],
            ['形状', '形状类型、路径、填充、描边、遮罩与羽化。'],
            ['字幕', '提示点时序与文本，以及字幕样式预设。'],
            ['调色', '色轮、曲线与调色工具（见特效与调色）。'],
          ],
        },
      ],
    },
    {
      title: '标记',
      blocks: [
        {
          kind: 'paragraph',
          text: '属性面板会在**标记**标题下列出项目中所有标记，按时间排序。该列表始终可用——未选中任何内容时，它显示在画布设置下方；选中某个标记时，显示在标记编辑器下方——因此无论选中什么，你都能浏览并访问自己的标记。',
        },
        {
          kind: 'list',
          items: [
            '每一行显示标记的颜色、其标签（若无标签则显示默认名称）以及时码。',
            '选中某行可将其设为活动标记，并将播放头跳转到该位置。',
            '使用某行上的垃圾桶图标可删除该单个标记。',
            '**清除全部**会一次性移除所有标记。',
          ],
        },
        {
          kind: 'note',
          tone: 'tip',
          text: '按 `M` 可在播放头处放置一个标记。当列表为空时，它会显示此提示。',
        },
        {
          kind: 'paragraph',
          text: '选中标记会在列表上方打开其编辑器，你可以在其中更改**帧**位置、编辑**标签**，并从预设色板设置**颜色**或将其重置为默认。**时间**字段以只读方式显示标记时码，**删除标记**会将其移除。',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
